import { useMemo } from "react";

import { PatientSingleResponseItem } from "@accurx/concierge/types";
import { Log } from "@accurx/shared";

import { PreviewSummaryTemplate } from "../../PreviewSummaryTemplate";

export type PatientResponseProps = {
    conversationItem: PatientSingleResponseItem;
};

export const PatientResponse = ({ conversationItem }: PatientResponseProps) => {
    const hasPatientResponded = conversationItem.sections.length > 0;

    const summary = useMemo(() => {
        if (hasPatientResponded) {
            const c = conversationItem.sections.find((section) => {
                return section.responses.some((response) => {
                    return response.answer && response.answer;
                });
            });

            const answer =
                c && c.responses[0].answer ? c.responses[0].answer : null;

            if (answer === null) {
                Log.error(
                    "Patient responded, but no answers were found in patient response object",
                );
                return "No response found";
            }

            return answer;
        }
        return "Patient did not respond";
    }, [conversationItem.sections, hasPatientResponded]);

    return (
        <PreviewSummaryTemplate
            note={hasPatientResponded ? "Patient" : "Accurx"}
            messageSummary={summary}
        />
    );
};
